// RESPA §8 / Reg Z 1026.36(d): the funded-unit count is a bare historical record.
// No tier, no dollars, no gap-to-next, no "earn more" framing anywhere.
export const COMPANY_VOLUME_AS_OF_PREFIX = 'as of';

export const COMPANY_VOLUME_LABEL = 'loans funded';
